define(
    "diy/undo-redo/executor/Factory",
    [
        'diy/undo-redo/executor/Server',
        'diy/undo-redo/executor/Client',
        'diy/undo-redo/constants'
    ],
    /**
     *
     * @param {module.undoRedo.Executor.Server} ExecutorServer
     * @param {module.undoRedo.Executor.Client} ExecutorClient
     * @param {module.undoRedo.constants} constants
     * @returns {*}
     */
    function (ExecutorServer, ExecutorClient, constants) {
        'use strict';
        var Factory;

        /**
         * @class module.undoRedo.Executor.Factory
         * @template module.undoRedo.Executor.Factory
         * @lends {module.undoRedo.Executor.Factory.prototype}
         * @constructor
         */
        Factory = Klazz.extend({
            /** @type {module.undoRedo.History} */
            history: null,
            /** @type {module.undoRedo.RemoteRequest} */
            backend: null,
            /** @type {module.undoRedo.Api} */
            api: null,
            /**
             *
             * @param {module.undoRedo.History} history
             * @param {module.undoRedo.RemoteRequest} backend
             * @param {module.undoRedo.Api} api
             */
            initialize: function initialize(history, backend, api) {
                this.history = history;
                this.backend = backend;
                this.api = api;
            },
            /**
             *
             * @param {String} type
             * @returns {module.undoRedo.Executor.Base|module.undoRedo.Executor.Client|module.undoRedo.Executor.Server}
             */
            build: function build(type) {
                var executor;
                switch (type) {
                    case constants.executionType.SERVER:
                        executor = new ExecutorServer(this.history, this.backend, this.api);
                        break;
                    case constants.executionType.CLIENT:
                        executor = new ExecutorClient(this.history, this.backend, this.api);
                        break;
                }

                return executor;
            }
        });

        return Factory;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/executor/Factory.js
 ** module id = 915
 ** module chunks = 0
 **/